import {ActionType} from "typesafe-actions";
import IAnalyticsAction from "../IAnalyticsAction";
import {showTutorial} from "../../../tutorial/actions";

export default function showTutorialHandler({ payload }: ActionType<typeof showTutorial>): IAnalyticsAction | undefined {
    switch (payload) {
        case "gameplay.levelmap.exitfoundtutorial":
            return {
                category: "interaction",
                object: "message",
                name: "show",
                addition: "gameplay_levelmap_exitfoundtutorial"
            };
    }
}